import axios from "axios"

const {
    REACT_APP_URI_CLIENT_TABLE,
    REACT_APP_URI_CLIENT_TABLE_FILTERS
} = process.env

export const fetchFilters = async () => {
    const route = REACT_APP_URI_CLIENT_TABLE_FILTERS

    const { data } = await axios.get(route)

    return data
}

export const fetchClients = async ({
    rol,
    page = 1,
    limit = 20,
    search = "",
    status = "",
    industry = "",
    location = "",
    sort = { field: "createdAt", order: "ASC" },
}) => {
    const offset = (page - 1) * limit
    
    const params = new URLSearchParams({
        rol,
        offset,
        limit,
        search,
        status,
        industry,
        location,
        sortField: sort.field,
        sortOrder: sort.order,
    })
    
    const route = `${REACT_APP_URI_CLIENT_TABLE}?${params.toString()}`

    const { data } = await axios.get(route)

    return data
}
